import WakefernSSO from './WakefernSSO';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { withRouter } from 'react-router-dom';

// Action Creators
import { createNewUserOrSignIn } from '../../redux/auth/actions';
import { setLoading } from '../../redux/loading/actions';

// Redux
const mapStateToProps = (state) => {
  return {};
}

const mapDispatchToProps = (dispatch) => {
  return bindActionCreators({
    createNewUserOrSignIn,
    setLoading
  }, dispatch);
}

const ConnectedWakefernSSO = connect(
  mapStateToProps,
  mapDispatchToProps
)(withRouter(WakefernSSO));

export default ConnectedWakefernSSO;



// WEBPACK FOOTER //
// ./src/pages/WakefernSSO/index.js